import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import classNames from 'classnames';
import api from '@/api/services/blog';
import LoadingBalls from '@/components/Common/LoadingBalls';
import styles from '@/components/Blogs/blog-list.module.scss';
import BlogCard from '@/components/Blogs/Card/Card';

const Blogs = () => {
  const { data, isLoading, isValidating } = api.useBlogList({
    pageSize: 100,
    pageNumber: 1,
    sort: [
      {
        colId: 'index',
        sort: 'desc',
      },
    ],
    filter: {},
  });
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.titleWrapper}>
          <div className={styles.title}>LandRocker Blogs</div>
          <span className={styles.line} />
        </span>
        <span className={styles.subTitle}>Latest Blogs</span>
      </div>
      <div className={styles.innerContainer}>
        <div className={classNames(styles.boxCards_container, 'w-full')}>
          <div className='w-full'>
            {/* <InfiniteScroll
              dataLength={sortedData?.length} // Updated to use sortedData
              next={fetchMoreData}
              hasMore={sortedData?.length < latestNews.length + pressRelease.length} // Corrected hasMore logic
              loader={
                <div className='flex justify-center items-center w-full my-[40px]'>
                  <LoadingBalls />
                </div>
              }
            > */}
            {!data && isLoading && (
              <div className='mb-3 mt-7'>
                <LoadingBalls />
              </div>
            )}
            {data && (
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                {data?.data.items.map((item, index) => (
                  <BlogCard
                    key={item.Id}
                    item={{
                      description: 'Description',
                      id: item.Id,
                      image: { url: item.Image },
                      release: item.UpdatedAt * 1000,
                      title: item.Title,
                    }}
                  />
                ))}
              </div>
            )}
            {/* </InfiniteScroll> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
